<template>
  <div class="rightcontent" @click="hidesel">
    <div class="midContent">
      <div class="content">
        <div class="PageLayout_pano_1CLgjP">
          <div class="PanoContainer_container_3ZTueK PanoContainer_hide_4eJXqs">
            <div class="PanoContainer_panoContainer_2cvEqZ">
              <div id="panoContainer" class="PanoContainer_pano_pAw-Z2">
                <div
                  id="krpanoSWFObject"
                  tabindex="-1"
                  style="
                    position: relative;
                    overflow: hidden;
                    height: 100%;
                    line-height: normal;
                    font-weight: normal;
                    font-style: normal;
                    outline: 0px;
                    -webkit-tap-highlight-color: transparent;
                    background: rgb(0, 0, 0);
                    width: 100%;
                  "
                >
                  <div
                    style="
                      position: absolute;
                      left: 0px;
                      top: 0px;
                      width: 1092px;
                      height: 756px;
                      overflow: hidden;
                      user-select: none;
                      touch-action: none;
                      -webkit-tap-highlight-color: transparent;
                      cursor: default;
                    "
                  >
                    <div
                      style="
                        position: absolute;
                        left: 0px;
                        top: 0px;
                        width: 100%;
                        height: 100%;
                        overflow: hidden;
                        pointer-events: none;
                      "
                    >
                      <canvas
                        width="1092"
                        height="756"
                        style="
                          position: absolute;
                          left: 0px;
                          top: 0px;
                          width: 1092px;
                          height: 756px;
                        "
                      ></canvas>
                    </div>
                    <div
                      style="
                        position: absolute;
                        left: 0px;
                        top: 0px;
                        width: 100%;
                        height: 100%;
                        overflow: hidden;
                        user-select: none;
                        transform-style: preserve-3d;
                      "
                    ></div>
                  </div>
                  <div
                    style="
                      position: absolute;
                      left: 0px;
                      bottom: -1px;
                      width: 100%;
                      height: 156px;
                      overflow: hidden;
                      display: none;
                      transform: translateZ(2e12px);
                      z-index: 999999999;
                    "
                  >
                    <div
                      style="
                        position: absolute;
                        left: 0px;
                        top: 0px;
                        width: 100%;
                        height: 100%;
                        overflow: hidden;
                        background-color: rgb(0, 0, 0);
                        box-sizing: border-box;
                        border-top: 1px solid rgba(255, 255, 255, 0.8);
                        border-bottom: 1px solid rgba(255, 255, 255, 0.8);
                        opacity: 0.6;
                      "
                    ></div>
                    <pre
                      style="
                        position: absolute;
                        left: 5px;
                        top: 0px;
                        margin: 6px 0px;
                        padding: 0px 16px 0px 0px;
                        border: 0px;
                        border-radius: 0px;
                        width: 100%;
                        height: 146px;
                        overflow: hidden auto;
                        text-align: left;
                        white-space: pre-line;
                        text-size-adjust: none;
                        cursor: text;
                        display: block !important;
                        background: none !important;
                        font-family: 'Courier New' !important;
                        font-size: 11px !important;
                        line-height: 1.2 !important;
                        color: rgb(255, 255, 255) !important;
                      "
                    ><div>INFO: krpano 1.20.2 (build 2019-10-15)</div><div>INFO: HTML5/Desktop - Chrome 74.0 - WebGL</div><div>INFO: Registered to: OTHINK Technology Co.,Ltd.</div><div><span style="color:#FFFF00;">ERROR: jscall() - calling Javascript "window.onKrpViewFrameShow()" failed: TypeError: window.onKrpViewFrameShow is not a function</span> </div></pre>
                    <div
                      style="
                        position: absolute;
                        right: 0px;
                        top: 6px;
                        padding: 0px 4px;
                        height: 30px;
                        user-select: none;
                        cursor: pointer;
                        -webkit-tap-highlight-color: transparent;
                        font-family: 'Courier New';
                        font-size: 10px;
                        color: rgb(255, 255, 255);
                      "
                    >
                      CLOSE
                    </div>
                    <div
                      style="
                        position: absolute;
                        right: 2px;
                        bottom: 4px;
                        padding: 0px 4px 4px;
                        height: 14px;
                        user-select: none;
                        cursor: pointer;
                        -webkit-tap-highlight-color: transparent;
                        font-family: 'Courier New';
                        font-size: 14px;
                        color: rgb(170, 170, 170);
                      "
                    >
                      ⇵
                    </div>
                    <div
                      style="
                        position: absolute;
                        right: 0px;
                        bottom: 18px;
                        padding: 0px 4px 4px;
                        height: 12px;
                        user-select: none;
                        cursor: pointer;
                        -webkit-tap-highlight-color: transparent;
                        font-family: 'Courier New';
                        font-size: 10px;
                        color: rgb(15, 255, 0);
                        display: none;
                      "
                    >
                      LAYERS
                    </div>
                    <div
                      style="
                        position: absolute;
                        right: 0px;
                        bottom: 36px;
                        padding: 4px 4px 0px;
                        height: 12px;
                        user-select: none;
                        cursor: pointer;
                        -webkit-tap-highlight-color: transparent;
                        font-family: 'Courier New';
                        font-size: 10px;
                        color: rgb(15, 255, 0);
                        display: none;
                      "
                    >
                      HOTSPOTS
                    </div>
                    <div
                      style="
                        position: absolute;
                        right: 0px;
                        bottom: 50px;
                        padding: 4px 4px 0px;
                        height: 12px;
                        user-select: none;
                        cursor: pointer;
                        -webkit-tap-highlight-color: transparent;
                        font-family: 'Courier New';
                        font-size: 10px;
                        color: rgb(15, 255, 0);
                        display: none;
                      "
                    >
                      PANO
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="FillBlock-hzrSuI zVQab Settings_container_3lTPuv">
            <div
              style="
                position: relative;
                overflow: hidden;
                width: 100%;
                height: 100%;
              "
            >
              <div
                style="
                  position: absolute;
                  top: 0px;
                  left: 0px;
                  right: 0px;
                  bottom: 0px;
                  overflow: scroll;
                  margin-right: -17px;
                  margin-bottom: -17px;
                "
              >
                <div class="Settings_panel_3P81Vz">
                  <div class="BasicSettings_root_3N6ke2">
                    <div class="BasicSettings_header_2YVmZq">
                      <div class="BasicSettings_title_2_gReZ">基础设置</div>
                      <div
                        class="Checkbox_container_jYKPxJ"
                        @click="changePubic"
                      >
                        <div
                          :class="{
                            Checkbox_checkbox_2hIu2H: true,
                            Checkbox_checked_3yFHX3:
                              resData.length > 0 && resData[0].switchs.isPublic,
                          }"
                          style="width: 14px; height: 14px"
                        >
                          <span class="SVGInline"
                            ><svg
                              class="SVGInline-svg"
                              fill="#fff"
                              style="width: 10px; height: 10px"
                              width="8"
                              height="7"
                              viewBox="0 0 8 7"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M7.146 0l-4.36 4.39L.81 2.412 0 3.371l2.757 2.756L8 .854z"
                                fill-rule="evenodd"
                              ></path></svg
                          ></span>
                        </div>
                        <div class="Checkbox_label_3AqBz_">公开作品</div>
                      </div>
                    </div>
                    <div class="BasicSettings_body_2hqkdy">
                      <div class="CoverSetting_root_3p-fF5">
                        <div
                          class="CoverSetting_thumb_2hxvB6"
                          v-if="resData.length > 0 && resData[0].sceneCover"
                        >
                          <div
                            :style="{
                              width: '100%',
                              height: '100%',
                              'background-image':
                                'url(' + resData[0].sceneCover + ')',
                              'background-repeat': 'no-repeat',
                              'background-size': 'cover',
                              'background-position': 'center center',
                            }"
                          ></div>
                        </div>
                        <div class="CoverSetting_footer_3EFBoY">
                          <div>
                            <input
                              type="file"
                              accept="image/jpeg, image/png"
                              style="
                                position: absolute;
                                z-index: -1;
                                width: 0.1px;
                                height: 0.1px;
                                opacity: 0;
                                overflow: hidden;
                              "
                            />
                            <a
                              class="pano-button pano-button-sm pano-button-primary CoverSetting_btn_SSHxK_"
                              @click="editcover"
                              >修改封面</a
                            >
                          </div>
                          <div class="CoverSetting_tip_1arvr-">
                            <p>建议尺寸</p>
                            <p>512 X 512</p>
                          </div>
                        </div>
                      </div>
                      <div class="ProjectForm_root_3kYeyn">
                        <div
                          class="ProjectForm_row_IJvRnZ ProjectForm_channel_2SuB_F"
                        >
                          <div
                            class="pano-dropdown-container"
                            @click.stop="showsel"
                            role="combobox"
                            aria-expanded="false"
                            aria-haspopup="listbox"
                            aria-labelledby="downshift-3-label"
                          >
                            <el-select v-model="resData[0].labelID" placeholder="请选择" class="mySelect">
                              <el-option
                                v-for="item in items"
                                :key="item.id"
                                :label="item.labelName"
                                :value="item.id"
                              >
                              </el-option>
                            </el-select>
                          </div>
                        </div>
                        <div
                          class="ProjectForm_row_IJvRnZ"
                          v-if="resData.length > 0"
                        >
                          <input
                            type="text"
                            class="pano-input pano-input-md pano-input-dark"
                            name="name"
                            maxlength="50"
                            placeholder="作品标题"
                            v-model="resData[0].sceneName"
                          />
                          <div class="ProjectForm_count_2o1lyM"></div>
                        </div>
                        <div
                          class="ProjectForm_row_IJvRnZ"
                          v-if="resData.length > 0"
                        >
                          <textarea
                            class="pano-textarea pano-textarea-dark ProjectForm_textarea_1Us8XZ"
                            name="remark"
                            placeholder="作品简介"
                            v-model="resData[0].sceneContext"
                          ></textarea>
                        </div>
                        <div class="ProjectForm_row_IJvRnZ">
                          <a
                            class="pano-button pano-button-sm pano-button-primary ProjectForm_btn_27s8Yf"
                            @click="addlabel"
                            >添加标签</a
                          >
                          <div class="ProjectForm_tagList_12tr9l">
                            <div
                              class="ProjectForm_tag_NM-LmA"
                              title="沙滩"
                              v-for="item in labelitems"
                              @click="openlabel"
                              :key="item.id"
                            >
                              <span
                                class="ProjectForm_tagText_e0jC4- ellipsis"
                                >{{ item }}</span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="Container_root_3H9-wr">
                    <div class="Container_title_2phRys">全局设置</div>
                    <div class="Container_list_2D2bq7">
                      <!-- <a
                        class="pano-button pano-button-sm pano-button-primary SettingButton_btn_PJ3Wr7"
                        >开场提示</a
                      ><a
                        class="pano-button pano-button-sm pano-button-primary SettingButton_btn_PJ3Wr7"
                        >开场封面</a
                      ><a
                        class="pano-button pano-button-sm pano-button-primary SettingButton_btn_PJ3Wr7"
                        >开场动画</a
                      ><a
                        class="pano-button pano-button-sm pano-button-primary SettingButton_btn_PJ3Wr7"
                        >自定义初始场景</a
                      ><a
                        class="pano-button pano-button-sm pano-button-primary SettingButton_btn_PJ3Wr7"
                        >自定义LOGO</a
                      ><a
                        class="pano-button pano-button-sm pano-button-primary SettingButton_btn_PJ3Wr7"
                        >自定义按钮</a
                      ><a
                        class="pano-button pano-button-sm pano-button-primary SettingButton_btn_PJ3Wr7"
                        >界面模板</a
                      ><a
                        class="pano-button pano-button-sm pano-button-primary SettingButton_btn_PJ3Wr7"
                        >界面语言</a
                      ><a
                        class="pano-button pano-button-sm pano-button-primary SettingButton_btn_PJ3Wr7"
                        >访问密码</a
                      ><a
                        class="pano-button pano-button-sm pano-button-primary SettingButton_btn_PJ3Wr7"
                        >自动巡游</a
                      ><a
                        class="pano-button pano-button-sm pano-button-primary SettingButton_btn_PJ3Wr7"
                        >说一说</a
                      ><a
                        class="pano-button pano-button-sm pano-button-primary SettingButton_btn_PJ3Wr7"
                        >手机陀螺仪</a
                      ><a
                        class="pano-button pano-button-sm pano-button-primary SettingButton_btn_PJ3Wr7"
                        >自定义右键</a
                      > -->
                      <a
                        @click="openCode()"
                        class="pano-button pano-button-sm pano-button-primary SettingButton_btn_PJ3Wr7"
                        >二维码</a
                      >
                    </div>
                  </div>
                  <div>
                    <div class="ToggleSettings_title_1E32_F">全局开关</div>
                    <div class="ToggleSettings_toggles_3SUOhN">
                      <div
                        class="Item_item__pZ-oM"
                        v-for="(item, i) in items1"
                        :key="i"
                        @click="openorclose(item.id)"
                      >
                        <div class="Item_title_33SBKn">{{ item.name }}</div>
                        <img
                          :src="
                            resData.length > 0 &&
                            resData[0].switchs[item.id] == 1
                              ? active
                              : noactive
                          "
                          class="ToggleIcon_root_2QoX04"
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                  <div class="">
                    <el-switch
                      v-model="startupPage"
                      @change="changeStartupPage"
                      active-text="开启待机视频">
                    </el-switch>
                    <el-button
                      type="primary"
                      class="chooseVideo"
                      style="margin-left:20px"
                      @click="dialogVideo = true"
                      size="mini"
                      >选择视频</el-button
                    >
                    <el-button
                      type="primary"
                      class="choosePic"
                      style="margin-left:20px"
                      @click="dialogPic = true"
                      size="mini"
                      >选择待机图片</el-button
                    >
                  </div>
                  <div class="backUrlBox">
                    <p>返回链接:</p>
                    <input type="text" @change="backUrlChange" v-model="backUrl" name="" id="">
                  </div>
                </div>
              </div>
              <div
                style="
                  position: absolute;
                  height: 6px;
                  right: 2px;
                  bottom: 2px;
                  left: 2px;
                  border-radius: 3px;
                "
              >
                <div
                  style="
                    position: relative;
                    display: block;
                    height: 100%;
                    cursor: pointer;
                    border-radius: inherit;
                    background-color: rgba(0, 0, 0, 0.2);
                    width: 0px;
                    transform: translateX(0px);
                  "
                ></div>
              </div>
              <div
                style="
                  position: absolute;
                  width: 6px;
                  right: 2px;
                  bottom: 2px;
                  top: 2px;
                  border-radius: 3px;
                "
              >
                <div
                  style="
                    position: relative;
                    display: block;
                    width: 100%;
                    cursor: pointer;
                    border-radius: inherit;
                    background-color: rgba(0, 0, 0, 0.2);
                    height: 0px;
                  "
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <RightAlert
      v-if="flag"
      @close="close1"
      @label="getlabels"
      :labels="labelitems"
    ></RightAlert>

    <input
      type="file"
      ref="inputUp"
      multiple
      style="display: none"
      @change="change1"
    />
    <my-database
      v-if="dialogPic"
      type="4"
      :closeFunc="closePic"
      :submitFunc="addPic"
    ></my-database>
    <my-database
      v-if="dialogVideo"
      type="6"
      :closeFunc="closeVideo"
      :submitFunc="addVideo"
    ></my-database>
  </div>
</template>
<style>
.mySelect .el-input__inner {
  background-color: #2c2c2c;
    border-color: #525252 !important;
    color: #fff !important;
}
</style>
<style scoped>
* {
  text-align: left;
}
.Checkbox_checked_3yFHX3 {
  background-color: #427afb !important;
  border-color: #427afb !important;
}
.ProjectForm_textarea_1Us8XZ {
  height: 65px !important;
}
.pano-textarea-dark {
  background-color: #2c2c2c;
  border-color: #525252 !important;
  color: #fff !important;
}
.SidebarBasic_tip_3O5NaE {
  -webkit-box-flex: 1;
  -ms-flex: 1 auto;
  flex: 1 auto;
  color: #aaa;
  line-height: 15px;
  font-size: 12px;
}
.PageLayout_sidebar_1JSEld {
  -ms-flex: 0 0 230px;
  flex: 0 0 230px;
  width: 230px;
  height: 100%;
}
.PageLayout_sidebar_1JSEld,
.PageLayout_toolbar_2y1UEJ {
  position: relative;
  -webkit-box-flex: 0;
  border-color: #4b4b4b #000 #000 #4b4b4b;
  border-style: solid;
  border-width: 1px;
}
.SidebarBasic_container_184hvl {
  padding: 25px 24px;
}
.SidebarBasic_qr_3Lp2R9 {
  width: 180px;
  height: 180px;
  margin-top: 10px;
  margin-bottom: 10px;
  background-color: #4b4b4b;
}
.SidebarBasic_footer_nsZNPm {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-flow: row nowrap;
  flex-flow: row nowrap;
}
.SidebarBasic_divide_11cRv8 {
  margin: 30px 0;
}
.SidebarBasic_row_2FP8Ti {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin-bottom: 10px;
}
.link {
  color: #427afb;
  cursor: pointer;
}
.pano-input-dark:disabled {
  background-color: #333;
  color: #777 !important;
}
button[disabled],
html input[disabled] {
  cursor: default;
}
input[type="text"],
input[type="password"] {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  padding-left: 10px;
  padding-right: 10px;
  color: #333;
  border: #e9e9e9 1px solid;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
}
.pano-input-lg {
  height: 40px;
}
textarea {
  color: black;
}
.scroll2::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  /**/
}
.scroll2::-webkit-scrollbar-track {
  background: rgb(239, 239, 239);
  border-radius: 2px;
}
.scroll2::-webkit-scrollbar-thumb {
  background: #bfbfbf;
  border-radius: 10px;
}
.scroll2::-webkit-scrollbar-thumb:hover {
  background: #333;
}
.scroll2::-webkit-scrollbar-corner {
}
.PageLayout_pano_1CLgjP {
  position: relative;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  border-color: #4b4b4b #000 #000 #4b4b4b;
  border-style: solid;
  border-width: 1px;
}

.pano-dropdown-item {
  height: 24px;
  line-height: 24px;
  margin: 3px 0;
  cursor: pointer;
  padding: 0 15px;
  color: black;
}
.pano-dropdown-highlight {
  color: #fff;
  background-color: #447ef7;
}
.pano-dropdown-menu {
  position: absolute;
  min-width: 100%;
  z-index: 3000;
  color: #333;
  background: #fff;
  padding: 10px 0;
  border-radius: 2px;
  border: 1px solid #d8d8d8;
}
.PanoContainer_container_3ZTueK {
  position: absolute;
  width: 100%;
  height: 100%;
  padding: 15px;
  visibility: hidden;
}
.PanoContainer_panoContainer_2cvEqZ {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  -webkit-box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.7);
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.7);
}
.PanoContainer_pano_pAw-Z2 {
  width: 100%;
  height: 100%;
}
.zVQab {
  position: absolute;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
}
.Settings_panel_3P81Vz {
  margin: 0 auto;
  width: 900px;
}
.BasicSettings_root_3N6ke2 {
  margin-bottom: 35px;
}
.BasicSettings_header_2YVmZq {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin-bottom: 20px;
}
.BasicSettings_header_2YVmZq {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin-bottom: 20px;
}
.Checkbox_checkbox_2hIu2H,
.Checkbox_container_jYKPxJ {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  display: inline-flex;
}
.pano-dropdown-selected {
  -webkit-box-flex: 1;
  -ms-flex: 1 auto;
  flex: 1 auto;
  text-align: left;
}
.Settings_container_3lTPuv {
  padding: 40px 20px;
}
.Checkbox_checked_3yFHX3 {
  background-color: #427afb;
  border-color: #427afb;
}
.Checkbox_checkbox_2hIu2H {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  background-color: #fff;
  border: 1px solid #d8d8d8;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.Checkbox_label_3AqBz_ {
  margin-left: 5px;
  cursor: pointer;
}
.BasicSettings_helpIcon_3hEJb0 {
  margin-left: 10px;
}
.HelpIcon_root_WFV-sl {
  width: 18px;
  height: 18px;
}
.BasicSettings_body_2hqkdy {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.CoverSetting_root_3p-fF5 {
  -webkit-box-flex: 0;
  -ms-flex: 0 0 200px;
  flex: 0 0 200px;
  position: relative;
  margin-right: 20px;
  height: 200px;
  -webkit-box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.5);
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.5);
  background-color: #4b4b4b;
  border-radius: 5px;
  overflow: hidden;
}
.CoverSetting_thumb_2hxvB6 {
  height: 200px;
  background-color: #4b4b4b;
}
.CoverSetting_footer_3EFBoY {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  position: absolute;
  right: 0;
  left: 0;
  bottom: 10px;
}
.CoverSetting_tip_1arvr- {
  font-size: 12px;
  line-height: 15px;
  margin-left: 10px;
}
.ProjectForm_root_3kYeyn {
  -webkit-box-flex: 1;
  -ms-flex: 1 auto;
  flex: 1 auto;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-flow: column nowrap;
  flex-flow: column nowrap;
}
.ProjectForm_channel_2SuB_F {
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.pano-dropdown-container {
  position: relative;
}
.ProjectForm_select_3hwiAT {
  width: 200px;
  background-color: #2c2c2c;
  border: 1px solid #4b4b4b;
}
.pano-dropdown-trigger {
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  padding-right: 10px;
  padding-left: 10px;
  height: 34px;
  border-radius: 3px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  cursor: pointer;
  color: #333;
}
.DictSearch_container_L6Hx5J {
  position: relative;
}
input[type="text"],
input[type="password"] {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  padding-left: 10px;
  padding-right: 10px;
  color: #333;
  border: #e9e9e9 1px solid;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
}
.ProjectForm_count_2o1lyM {
  position: absolute;
  top: 50%;
  right: 0;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  font-size: 12px;
  color: #777;
}

.ProjectForm_row_IJvRnZ {
  position: relative;
  width: 100%;
  margin-bottom: 10px;
  padding-right: 50px;
}
.ProjectForm_count_2o1lyM {
  position: absolute;
  top: 50%;
  right: 0;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  font-size: 12px;
  color: #777;
}
.ProjectForm_row_IJvRnZ {
  position: relative;
  width: 100%;
  margin-bottom: 10px;
  padding-right: 50px;
}
.ProjectForm_textarea_1Us8XZ {
  height: 65px;
}
.ProjectForm_textarea_1Us8XZ {
  height: 65px;
}
.pano-textarea {
  overflow: auto;
  resize: none;
  width: 100%;
  height: 120px;
  border-radius: 2px;
  padding: 10px;
  line-height: 20px;
  -webkit-transition: border-color 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
  transition: border-color 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
  -o-transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
  font-size: 14px;
}
.ProjectForm_row_IJvRnZ {
  position: relative;
  width: 100%;
  margin-bottom: 10px;
  padding-right: 50px;
}
.ProjectForm_btn_27s8Yf {
  width: 85px;
  padding: 0;
}
.ProjectForm_btn_27s8Yf {
  width: 85px;
  padding: 0;
}
.pano-button-primary {
  background-color: #286efa;
  color: #fff;
}
.ProjectForm_tagList_12tr9l {
  -webkit-box-flex: 1;
  -ms-flex: 1 auto;
  flex: 1 auto;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-flow: row wrap;
  flex-flow: row wrap;
  margin-top: 10px;
}
.ProjectForm_tag_NM-LmA {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin-left: 10px;
  height: 30px;
  padding: 0 15px;
  background-color: #4b4b4b;
  color: #aaa;
  border-radius: 3px;
  cursor: pointer;
}
.ProjectForm_tagText_e0jC4- {
  max-width: 95px;
}
.ellipsis {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  min-height: 1em;
}
.ProjectForm_tag_NM-LmA {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin-left: 10px;
  height: 30px;
  padding: 0 15px;
  background-color: #4b4b4b;
  color: #aaa;
  border-radius: 3px;
  cursor: pointer;
}
.Container_root_3H9-wr {
  margin-bottom: 35px;
}
.Container_title_2phRys {
  margin-bottom: 20px;
  font-size: 16px;
}
.Container_list_2D2bq7 {
  margin-left: -20px;
}
.SettingButton_btn_PJ3Wr7 {
  margin-left: 20px;
  margin-bottom: 20px;
}
.ToggleSettings_title_1E32_F {
  margin-bottom: 20px;
  font-size: 16px;
}
.backUrlBox{
  width: 100%;
  height: 30px;
  position: relative;
  margin-top: 20px;
}
.backUrlBox p{
  width: 120px;
  height: 30px;
  font-size: 20px;
  position: absolute;
  left: 0;
  line-height: 30px;
}
.backUrlBox input{
  position: absolute;
  left: 120px;
  height: 30px;
  font-size: 20px;
  background-color: #2c2c2c;
  border-color: #525252 !important;
  color: #fff !important;
  width: 700px;
}
.ToggleSettings_toggles_3SUOhN {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin-right: -30px;
}
.ToggleSettings_toggles_3SUOhN {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  margin-right: -30px;
}
.Item_title_33SBKn {
  margin-right: 5px;
}
.ToggleIcon_root_2QoX04 {
  width: 40px;
  height: 20px;
  cursor: pointer;
}
.Item_item__pZ-oM {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin-right: 30px;
  margin-bottom: 25px;
  cursor: pointer;
}
.pano-button {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  height: 30px;
  padding-left: 15px;
  padding-right: 15px;
  border-radius: 3px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  cursor: pointer;
  white-space: nowrap;
}

.pano-input-md {
  height: 34px;
}
.pano-input-dark {
  background-color: #2c2c2c;
  border-color: #525252 !important;
  color: #fff !important;
}
.pano-dropdown-container {
  position: relative;
}
.pano-input {
  width: 100%;
  border-radius: 2px;
  padding-left: 10px;
  padding-right: 10px;
  border-style: solid;
  border-width: 1px;
  -webkit-transition: border-color 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
  transition: border-color 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
  -o-transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out,
    -webkit-box-shadow 0.15s ease-in-out;
  font-size: 14px;
}
.ProjectForm_subTitle_hRQ5KB {
  width: 415px;
}
.BasicSettings_title_2_gReZ {
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  font-size: 16px;

  text-align: left;
}
.ProjectForm_channel_2SuB_F {
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.CoverSetting_btn_SSHxK_ {
  width: 85px;
  padding: 0;
}
.Item_title_33SBKn {
  margin-right: 5px;
}
.ToggleIcon_root_2QoX04 {
  width: 40px;
  height: 20px;
  cursor: pointer;
}
.ProjectForm_tagText_e0jC4- {
  max-width: 95px;
}
.rightcontent {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 1;
  -ms-flex: auto;
  flex: auto;
}
.midContent {
  position: relative;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-flow: column nowrap;
  flex-flow: column nowrap;
  background-color: #333;
  color: #fff;
  box-sizing: border-box;
}
.content {
  position: relative;
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
  border-color: #4b4b4b #000 #000 #4b4b4b;
  border-style: solid;
  border-width: 1px;
  box-sizing: border-box;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-flow: column nowrap;
  flex-flow: column nowrap;
}
.content h2 {
  height: 100%;
  text-align: center;
  vertical-align: middle;
  line-height: 100%;
}
</style>
<script>
import https from '../https.js'
import RightAlert from '../components/rightAlert.vue'
import axios from 'axios'
import md5 from 'js-md5'
import MyDatabase from '../components/database.vue'
export default {
  name: '',
  components: {
    RightAlert,
    MyDatabase
  },
  props: ['res', 'nowFloor', 'resData'],
  computed: {
    scenetype: function () {
      var name = ''
      for (var i = 0; i < this.items.length; i++) {
        if (this.infos.labelID == this.items[i].id) {
          name = this.items[i].name
        }
      }
      return name
    }
  },
  watch: {
    infos(val) {
      if (val != '') {
        if (this.infos.worksLabel != null) {
          var a = this.infos.worksLabel
          var b = a.split(',')
          this.labelitems = b
        }

        for (var i = 0; i < this.items.length; i++) {
          if (this.infos.labelID == this.items[i].id) {
            this.select = this.items[i].name
            this.index = i
          }
        }
      }
    },
    resData(val) {
      if(!this.hasInit) {
        console.log(val)
        this.hasInit = true
        this.startupPage = val[0].startupPage
        if(val[0].startupPage == 'true') {
          this.startupPage = true
        }else{
          this.startupPage = false
        }
        console.log(this.startupPage)
      }
    }
  },
  data() {
    return {
      select: '',
      show: false,
      startupPage: false,
      dialogPic: false,
      dialogVideo: false,
      backUrl: '',
      items: [
        // { id: "70101a01-97a4-4c8b-803d-6c291dcdeabd",labelName: "商业" },
        // { name: "村落", id: "395f7cef-a6c8-47de-b65f-539c477c31c2" },
        // { name: "景区", id: "a35e92a2-0601-4ee4-9b73-dcc2e86cb359" },
        // { name: "商业案例", id: "64ddf1ff-e1f5-445c-ade4-0e9f88091fdf" },
        // { name: "纪实", id: "33491ac3-bc56-4920-bf3b-12b0ea4cda52" },
        // { name: "高校", id: "52607ac7-c51d-43c4-bde2-643e63594d13" },
        // { name: "城市", id: "40e0229f-bd10-47d2-a2ca-275becd12a8d" },
        // { name: "3D设计", id: "414b931f-3f52-4750-ae21-d30a398e1fc6" },
        // { name: "汽车", id: "c1094d54-e865-4510-b42f-4d876da82d1b" },
        // { name: "建筑", id: "b767f942-1e10-461f-971c-1c87ca76b761" },
      ],
      items1: [
        { id: 'creatorName', name: '创作者名称' },
        { id: 'browserNumber', name: '浏览量' },
        { id: 'sceneSwitch', name: '场景选择' },
        { id: 'footmark', name: '足迹' },
        { id: 'like', name: '点赞' },
        { id: 'vr', name: 'VR眼镜' },
        { id: 'share', name: '分享' },
        { id: 'viewSwitch', name: '视角切换' },
        { id: 'sceneName', name: '场景名称' },
        { id: 'platFormMark', name: '平台标识' },
        { id: 'sceneAni', name: '小行星开场' },
        { id: 'footprint', name: '脚印' }
      ],
      flag: false,
      index: 0,
      index1: 0,
      active: './images/active.png',
      noactive: './images/noactive.png',
      flag1: false,
      labelitems: []
    }
  },
  created() {
    var a = this
  },
  mounted() {
    this.initLabel()
  },
  methods: {
    backUrlChange() {
      this.resData[0].backUrl = this.backUrl
    },
    changeStartupPage() {
      this.resData[0].startupPage = this.startupPage
    },
    closePic() {
      this.dialogPic = false
    },
    closeVideo() {
      this.dialogVideo = false
    },
    addPic(data) {
      console.log(data)
      this.resData[0].startupImg = data[0].filePath
    },
    addVideo(data) {
      this.resData[0].startupVideo = data[0].filePath
    },
    openCode() {},
    initLabel() {
      https.fetchGet('/api/Label/Get', {}).then((res) => {
        this.items = res.data
      })
    },
    changePubic() {
      if(this.resData[0].switchs.isPublic == 0) {
        this.resData[0].switchs.isPublic = 1
      }else{
        this.resData[0].switchs.isPublic = 0
      }
    },
    change1(e) {
      var files = e.target.files
      console.log(files)

      const $this = this

      const fileReader = new FileReader()
      const blobSlice =
        File.prototype.mozSlice ||
        File.prototype.webkitSlice ||
        File.prototype.slice
      const chunkSize = 2097152
      // read in chunks of 2MB
      const chunks = Math.ceil(files[0].size / chunkSize)
      let currentChunk = 0

      let bir = ''

      const formData = new FormData()

      formData.append('type', 100)

      // formData.append('type', 2)

      formData.append('file', files[0])
      fileReader.onload = function (e) {
        console.log('read chunk nr', currentChunk + 1, 'of', chunks)
        bir += e.target.result // append binary string
        formData.append('hashvalue', md5(bir))
        currentChunk++
        if (currentChunk < chunks) {
          loadNext()
        } else {
          console.log(md5(bir))

          console.log(formData.get('hashvalue'))
          var options = {
            // 设置axios的参数
            url: '/api/PhysicalFile/UploadFile',
            data: formData,
            method: 'post',
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
          axios(options).then((res) => {
            console.log(res)
            if (res.data.mes === '成功') {
              $this.$message({
                type: 'success',
                message: '上传成功',
                duration: 1000
              })

              $this.resData[0].sceneCover = res.data.filePath
            }
          })
        }
      }
      function loadNext() {
        var start = currentChunk * chunkSize
        var end =
          start + chunkSize >= files[0].size
            ? files[0].size
            : start + chunkSize
        fileReader.readAsBinaryString(blobSlice.call(files[0], start, end))
      }
      loadNext()
    },
    getlabels(data) {
      this.labelitems = data
      var a = data.join(',')
      this.infos.worksLabel = a
    },
    editcover() {
      this.$refs.inputUp.click()
    },
    openlabel() {
      this.flag1 = true
      this.flag = true
    },
    addlabel() {
      this.flag = true
    },
    close1(data) {
      this.flag = data
    },
    showsel() {
      this.show = !this.show
    },
    hidesel() {
      this.show = false
    },
    chooseop(i, item) {
      this.index = i
      this.select = item.labelName
      this.resData[0].labelID = JSON.stringify(item.id)
    },
    openorclose(id) {
      this.resData[0].switchs[id] = this.resData[0].switchs[id] == 0 ? 1 : 0
    }
  }
}
</script>
